import { useState } from 'react'

type DateRangePickerProps = {
  minStartDate: string
  maxEndDate: string
  startDate: string
  endDate: string
  runOnSubmit: (startDate: string, endDate: string) => Promise<void>
  sx?: React.CSSProperties
}

const DateRangePicker = ({
  sx,
  minStartDate,
  maxEndDate,
  startDate,
  endDate,
  runOnSubmit
}: DateRangePickerProps) => {
  const [currentInitialDate, setCurrentInitialDate] = useState(startDate)
  const [currentEndDate, setCurrentEndDate] = useState(endDate)

  const handleStartDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedDate = event.target.value

    setCurrentInitialDate(selectedDate)
    if (
      selectedDate &&
      currentEndDate &&
      new Date(selectedDate) > new Date(currentEndDate)
    ) {
      setCurrentEndDate('')
    }
  }

  const handleEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentEndDate(event.target.value)
  }

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    await runOnSubmit(currentInitialDate, currentEndDate)
  }

  return (
    <form
      style={{
        display: 'flex',
        gap: 16,
        ...((sx as React.CSSProperties) || {})
      }}
      onSubmit={onSubmit}
    >
      <input
        type="date"
        min={minStartDate}
        value={currentInitialDate}
        onChange={handleStartDateChange}
        placeholder="Start Date"
        style={{
          width: '105px',
          border: 'none',
          borderBottom: '1px solid #000',
          outline: 'none',
          padding: '5px 0'
        }}
      />
      <input
        type="date"
        value={currentEndDate}
        onChange={handleEndDateChange}
        min={minStartDate}
        max={maxEndDate}
        placeholder="End Date"
        style={{
          width: '105px',
          border: 'none',
          borderBottom: '1px solid #000',
          outline: 'none',
          padding: '5px 0'
        }}
      />

      <button
        type="submit"
        style={{
          padding: '5px 16px',
          border: 'none',
          color: 'white',
          backgroundColor: '#4b65d5'
        }}
      >
        Submit
      </button>
    </form>
  )
}

export { DateRangePicker }
